<div class="sidebar-container h-100">
  <ng-container *ngFor="let menu of menus; let i = index">
    <a @openClose *ngIf="menu.route && (!menu.role || currentUserRole(menu.role))" class="menu"
      [routerLink]="menu.route" routerLinkActive="menu-active">
      {{ menu.label | async }}
    </a>
    <div *ngIf="menu.submenu && (!menu.role || currentUserRole(menu.role))">
      <button class="menu text-left w-100" (click)="setOpenMenu(menu.key)"
        [ngClass]="{ 'menu-active': activeMenu === menu.key }">
        <i *ngIf="openMenu !== menu.key" class="pi  pi-angle-right"></i>
        <i *ngIf="openMenu === menu.key" class=" pi pi-angle-down "></i>
        {{ menu.label | async }}
      </button>
      <div @openClose *ngIf="openMenu === menu.key" class="submenu">
        <ng-container *ngFor="let submenu of menu.submenu">
          <a *ngIf="!submenu.role || currentUserRole(submenu.role)" class="menu" [routerLink]="submenu.route"
            routerLinkActive="menu-active">{{ submenu.label | async }}</a>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>